import styles from './Divider.module.css';

export const Divider = () => <hr className={styles.hr} />;
